(function () {
  class JackpotsContainer extends PIXI.Container {
    constructor() {
      super();

      this.jackpotValues = {
        miniJackpot: 0,
        minorJackpot: 0,
        majorJackpot: 0,
        maxiJackpot: 0,
        grandJackpot: 0,
      };

      const self = this;
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onGameConfigEvent();
      });
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    onGameConfigEvent() {
      this.jackpotValues = gameData.jackpotValues;
    }

    onLayoutComplete() {
      this.miniPotValue = resourceManager.get('jackpotsView:JackpotsContainer:jackpotValues:miniPotValue');
      this.minorPotValue = resourceManager.get('jackpotsView:JackpotsContainer:jackpotValues:minorPotValue');
      this.majorPotValue = resourceManager.get('jackpotsView:JackpotsContainer:jackpotValues:majorPotValue');
      this.maxiPotValue = resourceManager.get('jackpotsView:JackpotsContainer:jackpotValues:maxiPotValue');
      this.grandPotValue = resourceManager.get('jackpotsView:JackpotsContainer:jackpotValues:grandPotValue');

      this._layoutComplete = true;
    }

    onOrientationChange() {
      if (!this._layoutComplete) return;
    }

    updatePots(stake = resourceManager.getController('stakeController').BaseStake) {
      if ((gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) && gameData.encoreEnabled) {
        stake = resourceManager.getController('stakeController').getBaseStake(GLOBALS.LUCKYBET_BUY);
      }

      if (this.jackpotValues != null) {
        const { miniJackpot, minorJackpot, majorJackpot, maxiJackpot, grandJackpot } = this.jackpotValues;

        this.miniPotValue.setText(gdk.formatCurrency((miniJackpot * stake) / 10, false));
        this.minorPotValue.setText(gdk.formatCurrency((minorJackpot * stake) / 10, false));
        this.majorPotValue.setText(gdk.formatCurrency((majorJackpot * stake) / 10, false));
        this.maxiPotValue.setText(gdk.formatCurrency((maxiJackpot * stake) / 10, false));
        this.grandPotValue.setText(gdk.formatCurrency((grandJackpot * stake) / 10, false));
      }
    }
  }

  create = function (json) {
    return new JackpotsContainer();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('JackpotsContainer', create, initialise, getFilesRequired);
})();
